import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import * as customerApi from "../../../api/customer";

export function useCustomers(searchCategoryIdx, searchText) {
  const isSearch = searchText && searchCategoryIdx !== undefined;

  return useInfiniteQuery({
    queryKey: isSearch
      ? ["customers", "search", searchCategoryIdx, searchText]
      : ["customers"],
    queryFn: ({ pageParam = 1 }) => {
      if (isSearch) {
        return customerApi.search(
          null,
          {
            categoryIdx: searchCategoryIdx,
            text: searchText,
          },
          pageParam,
        );
      }
      return customerApi.fetchAll(null, pageParam);
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.hasNext) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
  });
}

export function useUpdateCustomer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => customerApi.update(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["customers"] }),
  });
}
